import { Box, styled, Typography } from '@mui/material';
import React, { useEffect, useMemo, useState } from 'react';
import { m, useAnimation } from 'framer-motion';
import { useDispatch, useSelector } from '../redux/store';
import CustomModal from './CustomModal';
import { closePopupCreditReward } from '../redux/slices/settings';
// import Image from './Image';
import useLocales from '../hooks/useLocales';
import { DEFAULT_CURRENCY_CODE } from '../config';
import { fNumberDecimal } from '../utils/formatNumber';
import { getGameCategsAndCompanies } from '../redux/slices/lookup';
// import useResponsive from '../hooks/useResponsive';

// const DefaultDynamicStyles = {
//   svgTitleFontSize: '3rem',
//   svgAmountFontSize: '3.5rem',
//   svgHeight: '3.5rem',
//   svgBottomText: '1.5rem',
// };

const DynamicText = styled(Typography)(({ theme }) => ({
  fontWeight: 900,
  textAlign: 'center',
  fontFamily: "'Arial Black', sans-serif",
  color: 'black' /* black fill inside */,
  textShadow: '0 0 2px #ffd700,0 0 4px #ffd700,0 0 6px #ffb700,0 0 8px #ffb700' /* glowing gold edge effect */,
  webkittextStroke: '2px transparent',
  // -webkit-text-stroke: "2px transparent"; /* no solid stroke */
  background: 'linear-gradient(to bottom, #ffd700, #ffb700, #b8860b)',
  WebkitBackgroundClip: 'text',
  backgroundClip: 'text',
}));

const congratsImageSrc = {
  en: require('../assets/promo/congrats-eng.png'),
  my: require('../assets/promo/congrats-my.png'),
  bn: require('../assets/promo/congrats-bn.png'),
};

const PopupCreditReward = () => {
  const { translate, currentLang } = useLocales();

  const { popupCreditReward, memberBalance } = useSelector((x) => ({ ...x.settings, ...x.lookup }));

  // const [dynamicStyles, setDynamicStyles] = useState(DefaultDynamicStyles);

  const dispatch = useDispatch();

  // const isXs = useResponsive('only', 'xs');

  const controls = useAnimation();
  const [displayAmount, setDisplayAmount] = useState(0);

  const currentLangValue = useMemo(() => {
    if (['my', 'bn'].includes(currentLang?.value)) return currentLang?.value; // These are the only locales supported

    return 'en';
  }, [currentLang]);

  // useEffect(() => {
  //   if (isXs) {
  //     setDynamicStyles(() => ({
  //       svgTitleFontSize: '3.3rem',
  //       svgAmountFontSize: '3.7rem',
  //       svgHeight: '3.5rem',
  //       svgBottomText: '4.4vw',
  //     }));
  //   } else {
  //     setDynamicStyles(DefaultDynamicStyles);
  //   }
  // }, [isXs]);

  useEffect(() => {
    if (!popupCreditReward.isOpen) {
      setDisplayAmount(0);
      return;
    }

    const runAnimation = () => {
      controls.start({
        scale: [0, 1.1, 1],
        transition: { duration: 1 },
      });

      let start = 0;
      const end = popupCreditReward.rewardAmount || 0;
      const duration = 1100;
      const stepTime = 20;
      const increment = end / (duration / stepTime);

      let interval;

      setTimeout(() => {
        interval = setInterval(() => {
          start += increment;
          if (start >= end) {
            start = end;
            clearInterval(interval);
          }
          setDisplayAmount(start);
        }, stepTime);
      }, 1000);

      return () => clearInterval(interval);
    };

    const timeout = setTimeout(runAnimation, 100); // slight delay to ensure visibility

    return () => clearTimeout(timeout);
  }, [controls, popupCreditReward.isOpen, popupCreditReward.rewardAmount]);

  return (
    <CustomModal
      maxWidth="xs"
      open={popupCreditReward.isOpen}
      onClose={() => {
        dispatch(closePopupCreditReward());
        getGameCategsAndCompanies();
      }}
      paperPropsSx={{
        borderWidth: 0,
        backgroundImage: `
          linear-gradient(to top, rgba(0, 0, 0, 0.5), transparent 40%, transparent 20%, rgba(0, 0, 0, 0.8)),
          url(${require('../assets/promo/promo-popup-bg.png')})
        `,
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'auto 100%',
        boxShadow: 'unset',
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', p: 2 }}>
        <img alt="logo" style={{ width: '60%', mb: 2 }} src={require('../assets/logo-web.png')} />
        <Box sx={{ width: '40%' }}>
          <img alt="treasure" style={{ width: '100%' }} src={require('../assets/promo/treasure.png')} />
        </Box>
        <Box sx={{ mt: '-8%', width: '100%', minHeight: { xs: '40px', sm: '50px', md: '103px' }, maxHeight: '103px' }}>
          <img alt="congrats" src={congratsImageSrc[currentLangValue]} style={{ width: '100%', height: '100%' }} />
        </Box>

        {/* Dynamic Text here */}
        <Box sx={{ mt: currentLangValue === 'en' ? '-8%' : '1%' }}>
          {currentLangValue === 'en' ? (
            <Box
              sx={{
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
                overflow: 'visible',
              }}
            >
              {/* <SvgLinearText
                text={translate('you_just_received')}
                fontSize={dynamicStyles.svgTitleFontSize}
                height={dynamicStyles.svgHeight}
              /> */}
              <DynamicText sx={{ fontSize: { xs: '6.5vw', sm: '2.2rem', lineHeight: 1 } }}>
                {translate('you_just_received')}
              </DynamicText>
            </Box>
          ) : (
            ''
          )}

          <Box
            component={m.div}
            sx={{
              width: '100%',
              display: 'flex',
              justifyContent: 'center',
              mt: { xs: '-2%', sm: '-2%', md: '-1%' },
            }}
            initial={{ scale: 0 }}
            animate={controls}
            transition={{ duration: 1, ease: 'easeIn' }}
          >
            {/* <SvgLinearText
              viewBox={'0 0 400 60'}
              text={`${DEFAULT_CURRENCY_CODE || memberBalance?.currencyCode}${fNumberDecimal(displayAmount)}`}
              fontSize={dynamicStyles.svgAmountFontSize}
              height={dynamicStyles.svgHeight}
            /> */}
            <DynamicText sx={{ fontSize: { xs: '6.7vw', sm: '2.5rem' } }}>{`${
              DEFAULT_CURRENCY_CODE || memberBalance?.currencyCode
            }${fNumberDecimal(displayAmount)}`}</DynamicText>
          </Box>

          {['my', 'bn'].includes(currentLangValue) ? (
            // Gradient Text here
            <Typography
              sx={{
                background: 'linear-gradient(180deg, #EBB141 30%, #B16C0A 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                fontSize: { xs: '5.4vw', sm: '1.5rem' },
                textAlign: 'center',
                fontWeight: 900,
              }}
            >
              {translate('credit_popup_bot_message')}
            </Typography>
          ) : (
            ''
          )}
        </Box>
      </Box>
    </CustomModal>
  );
};

export default PopupCreditReward;

// const SvgLinearText = ({
//   text,
//   gradientId = 'strokeGradient',
//   fontSize,
//   height = '3.5rem',
//   viewBox = '0 0 400 50',
// }) => (
//   <svg viewBox={viewBox} preserveAspectRatio="xMidYMid meet" width="100%" height={height}>
//     <defs>
//       <linearGradient id={gradientId} x1="0%" y1="0%" x2="0%" y2="100%">
//         <stop offset="0%" stopColor="#936900" />
//         <stop offset="40%" stopColor="#936900" />
//         <stop offset="100%" stopColor="#FFE797" />
//       </linearGradient>
//     </defs>
//     <text
//       x="50%"
//       y="50%"
//       dominantBaseline="middle"
//       textAnchor="middle"
//       fontSize={fontSize}
//       fontFamily="Bebas Neue, Impact, sans-serif"
//       fill="black"
//       stroke={`url(#${gradientId})`}
//       strokeWidth="2"
//     >
//       {text}
//     </text>
//   </svg>
// );
